import { paths } from '@/app/router/paths';
import type { Order, OrderAccess } from '@/entities/order';

import { inspectionsCopy } from './copy';

/**
 * De eerste knop in de detailbalk: wat je nú met deze keuring doet. Hij volgt
 * de status en wat deze sessie mag, en is altijd een echte handeling - een
 * navigatie naar een scherm waar het werk ligt, of een formulier.
 */
export type NextAction =
    | { kind: 'schedule'; label: string }
    | { kind: 'invoice'; label: string }
    | { kind: 'navigate'; label: string; to: string };

function surveyPathFor(order: Order): string | null {
    return order.inspection ? paths.inspectionFor(order.inspection) : null;
}

export function canSchedule(order: Order, access: OrderAccess): boolean {
    return access.assign && ['new', 'confirmed', 'scheduled'].includes(order.status);
}

export function nextActionFor(order: Order, access: OrderAccess): NextAction {
    const dossier: NextAction = {
        kind: 'navigate',
        label: inspectionsCopy.detailOpenOrder,
        to: paths.dossier(order.uuid),
    };
    const survey = surveyPathFor(order);

    switch (order.status) {
        case 'new':
        case 'confirmed':
            return canSchedule(order, access)
                ? { kind: 'schedule', label: inspectionsCopy.actionSchedule }
                : dossier;
        case 'scheduled':
            if (survey) {
                return { kind: 'navigate', label: inspectionsCopy.actionOpenSurvey, to: survey };
            }

            return canSchedule(order, access)
                ? { kind: 'schedule', label: inspectionsCopy.actionReschedule }
                : dossier;
        case 'surveying':
            return survey
                ? { kind: 'navigate', label: inspectionsCopy.actionOpenSurvey, to: survey }
                : dossier;
        case 'draft_report':
            return {
                kind: 'navigate',
                label: inspectionsCopy.actionReviewReport,
                to: paths.report(order.uuid),
            };
        case 'completed':
            return access.invoices && access.manage
                ? { kind: 'invoice', label: inspectionsCopy.actionInvoice }
                : dossier;
        case 'invoiced':
            return access.invoices
                ? { kind: 'navigate', label: inspectionsCopy.actionInvoices, to: paths.billing }
                : dossier;
        default:
            return dossier;
    }
}
